var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mds-tabs',{staticClass:"panel-tabs",attrs:{"content":_vm.tabsContent},on:{"mds-tabs-item-active":function($event){$event.preventDefault();return _vm.setActiveItem.apply(null, arguments)}}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }